import { render, staticRenderFns } from "./DispensingAddNumberOfDays.vue?vue&type=template&id=1369bd24"
import script from "./DispensingAddNumberOfDays.vue?vue&type=script&lang=js"
export * from "./DispensingAddNumberOfDays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports